import React from 'react';
// import dateFns from 'date-fns';
// import moment from 'moment';
import { format, parse, isValid } from 'date-fns';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import classNames from 'classnames';


const styles = theme => ({
  listContainer: {
    margin: 'auto',
    width: '95%',
  },
});

class ActionsList extends React.Component {
  state = {
  };

  createData = (id, name, data) => ({ id, name, data })

  renameAction = (action) => {
    if (action.action === 'REM' && action.categoryRemake === 'REM') {
      action.name = 'reativar';
    } else if (action.action === 'REM') {
      action.name = 'inativar';
    }

    if (action.action === 'SUB') {
      action.name = 'editar';
    }

    if (action.action === 'ADD') {
      action.name = 'adcionar';
    }

    if (action.action === 'VAL') {
      action.name = 'validar';
    }

    if (action.action === 'CHECK') {
      action.name = `${action.isCheckPoint ? '' : 'des'}considerar como checkpoint`;
    }

    if (action.action === 'FAL') {
      action.name = 'falta';
    }
    if (action.action === 'OFF') {
      action.name = 'ativar';
    }

    return action;
  }

  rows = [];
  mountRows = () => {
    this.rows = this.props.actions.map((a) => {
      a = this.renameAction(a);

      let date = a.dtRegister;
      if (!isValid(date)) {
        if (a.action === 'CHECK') 
          date = new Date(a.dtRegister.replace('Z', ''))
        else
          date = parse(a.dtRegister, 'yyyy-MM-dd HH:mm', new Date());
      }

      return this.createData(a.id, a.name, format(date, 'HH:mm'));
    });
  }


  undoAction = (action) => {
    this.props.undoAction(action);
    this.forceUpdate();
  }

  SimpleTable = () => {
    const { classes } = this.props;
    this.mountRows();

    return (
      <Paper elevation={2} className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell align="center" >Ações</TableCell>
              <TableCell align="center" >Ponto</TableCell>
              <TableCell align="center" >Desfazer</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.rows.map(row => (
              <TableRow key={row.id}>
                <TableCell align="center" component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="center">{row.data}</TableCell>
                <TableCell align="center">
                  <Icon
                    onClick={() => this.undoAction(row)}
                  >
                      remove_circle_outline
                  </Icon>
                </TableCell>
              </TableRow>
              ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.listContainer)}>
        {this.SimpleTable()}
      </div>
    );
  }
}
export default withStyles(styles)(ActionsList);
